import { writable } from "svelte/store";

export const refetchGallery = writable<boolean>(false);
